import React, { cloneElement } from "react";
import { RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";

interface ILovCommercialPlans extends Omit<ILovComponent, "valueProperty" | "labelProperty" | "routeAPI">{
	efa001Id: number;
}

const LovCommercialPlansOfBusinessGroup: React.FC<ILovCommercialPlans> = ({
	name,
	control,
	efa001Id,
	...rest
}) => {
	const { translate, currentLanguage } = useTranslation();
	const optionComponent = (component:any,props:any) =>  cloneElement(
		component,
		props,
		<span>{props.data.label} [{formatDate(props.data.extendedProps.efe001Dtinicio, currentLanguage)} - {formatDate(props.data.extendedProps.efe001Dtfim, currentLanguage)}]</span>
	);

	return (
		<RCCLov 
			name={name} 
			control={control}
			routeAPI="BusinessGroup/LovCommercialPlansOfBusinessGroup"
			valueProperty="Efe001Id"
			labelProperty="Efe001Efd001Descricao"
			elementsPerPage={20}
			componentsFunctions={{option:(x,y) => optionComponent(x,y)}}
			extraParametersOnLoad={{
				efa001Id
			}}
			placeholder={translate("Digite para filtrar as opções")}
			{...rest}
		/>
	);};

export default LovCommercialPlansOfBusinessGroup;
